// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useState } from "react";
import { Grid } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import Datepicker from "components/CustomFields/Datepicker";
import CompaniesSelect from "components/CustomFields/CompaniesSelect";
import TablesCard from "components/CustomCards/TablesCard";

function TablesHistory() {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [companyId, setCompanyId] = useState(null);
  const [searchDisabled, setSearchDisabled] = useState(true);
  const [invoiceQuery, setInvoiceQuery] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [companyParam, setCompanyParam] = useState(searchParams.get("company") ?? null);
  const [invoiceSummaries, setInvoiceSummaries] = useState(null);

  const handleSetFromDate = (newDate) => setFromDate(newDate[0]);
  const handleSetToDate = (newDate) => setToDate(newDate[0]);

  const setCompanyAndEnableSearch = (e) => {
    setCompanyId(e);
    setSearchDisabled(false);
  };

  const searchInvoices = () => {
    let invQuery = {
      companyId: companyId,
      fromDate: fromDate,
      toDate: toDate,
      setInvoiceSummaries: setInvSummaries,
    };
    setInvoiceQuery(invQuery);
  };

  const setInvSummaries = (summaries) => {
    setInvoiceSummaries(summaries);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox my={3}>
        <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
          <SoftBox lineHeight={1}>
            <SoftTypography variant="h5" fontWeight="medium">
              Φίλτρα αναζήτησης
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              Επίλεξτε φίλτρα για την αναζήτηση ιστορικού τραπεζιού.
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
          <Grid container spacing={3} justifyContent="center" mb={3}>
            <CompaniesSelect
              xs={12}
              md={6}
              handler={setCompanyAndEnableSearch}
              initValue={companyParam}
            />

            <Datepicker
              xs={12}
              md={2}
              title="Από ημερομηνία"
              handler={handleSetFromDate}
              initialValue={fromDate}
            />
            <Datepicker
              xs={12}
              md={2}
              title="Έως ημερομηνία"
              handler={handleSetToDate}
              initialValue={toDate}
            />
            <Grid item xs={12} md={2}>
              <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="flex-end"
                height="100%"
              >
                <SoftBox display="flex" justifyContent="flex-end" mt={3}>
                  <SoftButton
                    variant="gradient"
                    color="info"
                    style={{ width: "100%" }}
                    onClick={searchInvoices}
                    disabled={searchDisabled}
                  >
                    ΑΝΑΖΗΤΗΣΗ
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
      <TablesCard {...invoiceQuery} />

      <Footer />
    </DashboardLayout>
  );
}

export default TablesHistory;
